import clsx from 'clsx';

interface MetricCardProps {
  label: string;
  value: string;
  sublabel?: string;
  highlight?: boolean;
}

export const MetricCard = ({ label, value, sublabel, highlight }: MetricCardProps) => {
  return (
    <div
      className={clsx(
        'rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition',
        highlight && 'border-brand/40 shadow-brand/10',
      )}
    >
      <p className="text-xs font-semibold uppercase tracking-widest text-slate-500">{label}</p>
      <p className="mt-2 text-2xl font-semibold text-slate-900">{value}</p>
      {sublabel && <p className="text-sm text-slate-500">{sublabel}</p>}
    </div>
  );
};
